module.exports = __webpack_public_path__ + "img/whats-logo.188a2786.png";